module.exports = __webpack_public_path__ + "static/D365-human-resource-management-822eb45c2179b64ac5c84a69286e246c.png";